import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import classNames from 'classnames';
import { PulseLoader } from 'react-spinners';
import LoadingOverlay from 'react-loading-overlay';
import { PagesIcon, TimeIcon, IphoneIcon, EmailOutlinedIcon, ErrorIcon } from '../../../../../common/icons';
import MoVeInMobileHeader from '../../../../../common/components/MoVeInMobileHeader';
import MoVeInMobileFooter from '../../../../../common/components/MoVeInMobileFooter';
import MyPageButton from '../../../../../common/components/MyPageButton';
import MyPageAlert from '../../../../../common/components/MyPageAlert';
import LabelInput from '../../../../../common/components/LabelInput';
import SupportTile from '../SupportTile';
import InstallersCard from '../InstallersCard/InstallersCard';
import { withWindowSize } from 'air-with-window-size';

import './MobileWelcome.css';
import WhereIsIdAdesioneModal from "../WhereIsIdAdesioneModal";

@inject('translationsStore', 'moveinStore')
@observer
class MobileWelcome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisibleWhereIsIdAdesioneModal: false,
    };
  }

  handleEnter = e => {
    if (e.key === 'Enter') {
      this.props.onIdAdesioneSubmit();
    }
  };

  onContactusClick = () => {
    // window.location.href = 'tel:+393459782557';
    window.open('tel:+393459782557', '_blank');
    return null;
  };

  render() {
    const { translationsStore, moveinStore, dataCollection } = this.props;
    const { isVisibleWhereIsIdAdesioneModal } = this.state;

    const cls = classNames({
      MobileWelcome: true
    });

    const style1 = {
      color: 'var(--black-color)',
      fontSize: '22px',
      fontWeight: 600,
      letterSpacing: '-0.7px',
      lineHeight: '32px'
    };

    return (
      <div className={cls}>
        <MoVeInMobileHeader />
        <div className="WelcomeView">
          <div style={{ ...style1, marginBottom: 16 }}>{translationsStore.translate('movein.stepWelcome.labelWelcomeIntro')}</div>
          <div style={{ marginBottom: 5, fontWeight: 600 }}>{translationsStore.translate('movein.stepWelcome.appInstruction')}</div>
          <div style={{ marginBottom: 16 }}>{translationsStore.translate('movein.stepWelcome.labelWelcomeHint')}</div>
          <LoadingOverlay
            active={moveinStore.loadingCheckIdAdesione}
            spinner={<PulseLoader sizeUnit={'px'} size={10} color={'var(--action-primary-color)'} loading={true} />}
            styles={{
              overlay: base => ({
                ...base,
                background: 'var(--grey-light-color-50)'
              })
            }}
          >
            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
              <LabelInput
                placeholder={'Inserisci codice di 6 cifre: ID MoveIn / ID Adesione'}
                value={moveinStore.draftIdAdesione}
                onChange={e => {
                  moveinStore.setDraftIdAdesione(e.target.value);
                }}
                onKeyUp={this.handleEnter}
                style={{ marginRight: 16, flexGrow: 2, flexBasis: 0 }}
              />
              <MyPageButton
                className={'WelcomeSubmit'}
                theme="primary"
                solid
                disabled={moveinStore.draftIdAdesione === '' || moveinStore.loadingCheckIdAdesione}
                onClick={this.props.onIdAdesioneSubmit}
                title={translationsStore.translate(`movein.stepWelcome.labelWelcomeSubmit`)}
                style={{ flexGrow: 1, flexBasis: 0, height: 40 }}
              />
            </div>
            <div className={'WhereIsIdAdesioneLink'} onClick={() => this.setState({isVisibleWhereIsIdAdesioneModal: true})}>
              {translationsStore.translate('movein.stepWelcome.whereIsIdAdesione')}
            </div>
            <WhereIsIdAdesioneModal visible={isVisibleWhereIsIdAdesioneModal} onCancel={()=> this.setState({isVisibleWhereIsIdAdesioneModal: false})}/>
          </LoadingOverlay>
          {moveinStore.lastError !== null && (
            <MyPageAlert
              style={{ marginTop: 16 }}
              message={translationsStore.translate('movein.stepWelcome.errorIdAdesioneInput')}
              description={translationsStore.translate('movein.stepWelcome.errorIdAdesioneInputDescription')}
              type="error"
              closable
              showIcon
              icon={<ErrorIcon width={20} height={20} />}
            />
          )}
          <div style={{ marginTop: 40, marginBottom: 16 }}>{translationsStore.translate('movein.stepWelcome.labelWelcomeSupport')}</div>
          <div className={'SupportTileContainer'}>
            <div className={'SupportTileGroup'}>
              <SupportTile
                icon={<PagesIcon width={24} height={24} />}
                themeColor="var(--action-custom-color)"
                title={translationsStore.translate('movein.stepWelcome.tilesSupport.weekdays.title')}
                description={translationsStore.translate('movein.stepWelcome.tilesSupport.weekdays.description')}
              />
            </div>
            <div className={'SupportTileGroup'}>
              <SupportTile
                icon={<TimeIcon width={24} height={24} />}
                themeColor="var(--action-warning-color)"
                title={translationsStore.translate('movein.stepWelcome.tilesSupport.time.title')}
                description={translationsStore.translate('movein.stepWelcome.tilesSupport.time.description')}
              />
            </div>
            <div className={'SupportTileGroup'}>
              <SupportTile
                icon={<IphoneIcon width={24} height={24} />}
                themeColor="var(--action-success-color)"
                title={translationsStore.translate('movein.stepWelcome.tilesSupport.phone.landlineFirst')}
                description={translationsStore.translate('movein.stepWelcome.tilesSupport.phone.tollfree')}
                style={{ cursor: 'pointer' }}
                onClick={this.onContactusClick}
              />
            </div>
            <div className={'SupportTileGroup'}>
              <SupportTile icon={<EmailOutlinedIcon width={24} height={24} />} themeColor="var(--action-info-color)" title={'movein@myair.io'} onClick={this.props.onEmailClick} />
            </div>
          </div>
          <div style={{ marginTop: 40, marginBottom: 16 }}>{translationsStore.translate('movein.stepWelcome.labelInstallersIntro')}</div>
          <InstallersCard theme="mobile" width={this.props.componentWidth} dataCollection={dataCollection} />
        </div>
        <MoVeInMobileFooter />
      </div>
    );
  }
}

export default withWindowSize(MobileWelcome);
